import { LANGUAGES_SHORT } from '.';

export const getIDFLink = (language: string) => {
  // eslint-disable-next-line @typescript-eslint/ban-ts-comment
  // @ts-ignore
  return LANGUAGES_SHORT[language] === 'ENG' ? 'IDFEngLink' : 'IDFLink';
};
